import { Box, Theme, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomTable from '../../common/customTable'
import { AlternativeAssetTableProps, AssetAllocationTable } from '../../../../redux-store/types/alternative'
import { AssetAllocationTableComponent, AssetAllocationTableHeader } from './AlternativeTable'
import { SortingObj } from '../../types'
import _ from 'lodash'



function AlternativeAssetTable(props: AlternativeAssetTableProps) {
    const { isLoading, completeData } = props

    //state
    const [originTableData, setOriginTableData] = useState<AssetAllocationTable[]>([])
    const [sortingObj, setSortingObj] = useState<SortingObj>({
        order: "desc",
        orderBy: ""
    })

    useEffect(() => {
        if (completeData?.result?.categoryWiseBreakup) {
            setOriginTableData(completeData?.result?.categoryWiseBreakup)
        }
    }, [completeData])


    const handleTableSorting = (id: "categoryType" | "investedValue" | "marketValue" | "gainLoss", orderType: "asc" | "desc") => {
        setSortingObj({ order: orderType, orderBy: id })
        setOriginTableData(pre => {

            if (id === "categoryType") {
                return _.orderBy(pre, [(item) => item.categoryType.toLowerCase()], [orderType])
            } else {
                return _.orderBy(pre, [(item) => item[id]], [orderType === 'asc' ? 'desc' : 'asc'])
            }
        }
        )
    }

    return (
        <Box sx={(theme: Theme) => ({
            borderRadius: '20px',
            padding: '25px 30px 45px 30px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
            border: `3px solid ${theme.palette.stroke.main}`,
            background: theme.palette.common.white,
            height: '100%',
            width: '100%'
        })}>
            <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Typography variant="h2" sx={{
                    marginBottom: '40px'
                }}>Asset Allocation</Typography>

            </Box>
            <Box mt={'20px'} width={'100%'}>
                <CustomTable
                    loadingRowsNum={3}
                    isLoading={isLoading}
                    tableBody={
                        <AssetAllocationTableComponent
                            tableBodyData={originTableData || []}
                            isLoading={isLoading}
                        />
                    }
                    tableData={originTableData || []}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },

                    }}
                    tableHeaderData={AssetAllocationTableHeader}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px"
                        }
                    }}
                    handleSort={handleTableSorting as any}
                    tableBodyCustomStyles={{
                        '& tr:last-child td': {
                            border: 0
                        }
                    }}
                    tableDataCount={originTableData?.length}
                    isPaginationVisible={false}
                    order={sortingObj.order}
                    orderBy={sortingObj.orderBy}
                />
            </Box>
        </Box>
    )
}

export default AlternativeAssetTable